// angular
import { Injectable } from '@angular/core';

// settings
import { settings } from '@configs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor() { }

  get isTabletScreen() {
    const { innerWidth } = window;
    return innerWidth < settings.screenBreakpoints.tablet;
  }

}
